export function addtoarray(arr, obj) {
  const array = [...arr];
  const newarray = [...array, obj];
  return newarray;
}
